import { AccordionDetails } from '@material-ui/core';
import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
var InputContainer = styled.div.withConfig({
  displayName: "SponsoFieldstyle__InputContainer",
  componentId: "sc-1jweh2e-0"
})(["width:inherit;margin:", " auto;"], getSpacing(1.5));
var AccordionDetailsColumn = styled(AccordionDetails).withConfig({
  displayName: "SponsoFieldstyle__AccordionDetailsColumn",
  componentId: "sc-1jweh2e-1"
})(["flex-direction:column;width:100%;"]);
export { AccordionDetailsColumn, InputContainer };